import { StyleSheet } from "react-native";
import { Platform } from "react-native";
import { Dimensions } from "react-native";

let deviceWidth = Dimensions.get("window").width;

console.log(deviceWidth);

if (Platform.OS === "ios") {
  global.platform = "ios";
} else if (Platform.OS === "android") {
  // other thing for android
  global.platform = "android";
} else if (Platform.OS === "web") {
  // it's on web!
  global.platform = "web";
} else {
  // you probably won't end up here unless you support another platform!
  global.platform = "web";
}

export default StyleSheet.create({
  inputMainView: {
    width: "20%",
    backgroundColor: "red",
    borderColor: "black",
  },
  payNoWBtns: {
    backgroundColor: "#3fb7f5",
    borderRadius: 7,
    borderWidth: 0,
    color: "white",
    fontFamily: "SFProText",
    fontWeight: "500",
    fontSize: 16,
    width: 261,
    // cursor: "pointer",
    padding: 4,
  },
  paymentSuccessHead: {
    fontSize: 28,
    fontFamily: "SFProText",
    fontWeight: "500",
    paddingTop: 20,
    paddingBottom: 20,
    color: "#000000",
  },
  submitBtns: {
    height: 40,
    width: 261,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#3fb7f5",
    borderRadius: 7,
    borderWidth: 0,
    color: "white",
    fontFamily: "SFProTextBold",
    fontSize: 16,
    // cursor: 'pointer',
    padding: 4,
    textAlign: "center",

    marginTop: 20,
  },
  submitBtnText: {
    color: "white",
    fontSize: 16,
    fontFamily: "SFProTextBold",
    textAlign: "center",
  },
  submitBtnsView: {
    marginTop: 15,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  otpCountDownText: {
    fontSize: 14,
    // fontFamily: 'Calibri',
    color: "#3fb7f5",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    padding: 5,
  },
  otpContainerStyle1: {
    // width: "100%",
    flexDirection: "row",
    marginVertical: 20,
    // flex: 1,
    justifyContent: "center",
    flexWrap: "wrap",
  },
  otpStyle: {
    padding: 5,
    margin: 10,
    fontSize: 16,

    height: 55,
    textAlign: "center",
    borderColor: Platform.OS == "web" ? "#f1f0f0" : "black",
    borderRadius: 8,
    // borderWidth: 0.5,
    borderWidth: 1,
    color: "#555",
    backgroundColor: "#f1f0f0",
    fontFamily: "SFProText",
  },

  otpStyle_SMALL_MOBILE: {
    width: 35,
    margin: 5,
  },
  otpStyle_MEDIUM_MOBILE: {
    width: 40, // changing from 47 to 40 to fix in  ios small devices
    margin: 5,
  },
  otpStyle_LARGE_MOBILE: {
    width: 50,
  },
  otpStyle_SMALL_TABLET: {
    width: 55,
  },
  otpStyle_MEDIUM_TABLET: {
    width: 57,
  },
  otpStyle_LARGE_TABLET: {
    width: 60,
  },
  otpStyle_LAPTOP: {
    width: 85,
  },
});
